import { c as _c } from "react/compiler-runtime";
import type { IconProps } from './Icon.types';
import { IconWrapper } from './IconWrapper';
const SmileOutline = t0 => {
  const $ = _c(5);
  let props;
  if ($[0] !== t0) {
    ({
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
  } else {
    props = $[1];
  }
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <path d="M10.936 18.923C11.9468 20.6705 13.8361 21.8461 16 21.8461C18.2011 21.8461 20.1181 20.6297 21.1154 18.8324M13.2374 13.2313C13.2374 13.5074 13.0135 13.7313 12.7374 13.7313C12.4612 13.7313 12.2374 13.5074 12.2374 13.2313C12.2374 12.9551 12.4612 12.7313 12.7374 12.7313C13.0135 12.7313 13.2374 12.9551 13.2374 13.2313ZM19.8141 13.2313C19.8141 13.5074 19.5903 13.7313 19.3141 13.7313C19.038 13.7313 18.8141 13.5074 18.8141 13.2313C18.8141 12.9551 19.038 12.7313 19.3141 12.7313C19.5903 12.7313 19.8141 12.9551 19.8141 13.2313ZM25.5 16C25.5 21.2467 21.2467 25.5 16 25.5C10.7533 25.5 6.5 21.2467 6.5 16C6.5 10.7533 10.7533 6.5 16 6.5C21.2467 6.5 25.5 10.7533 25.5 16Z" strokeLinecap="round" />;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== props) {
    t2 = <IconWrapper strokeWidth={1} {...props} variant="outline" viewBox="0 0 32 32">{t1}</IconWrapper>;
    $[3] = props;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
};
export { SmileOutline };